<template>
    <div>
        <el-drawer
            title="新建自有渠道实名制电子票"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
        >
            <div class="drawer-content">
				<div class="temp-table MT10">
				    <el-form
				        :model="formData"
				        ref="formData"
				        label-position="top"
				    >
						<el-form-item prop="sessionId" label="场次:" :rules="[{required: true, message: '场次不能为空'}]">
							<el-select v-model="formData.sessionId" size="small" style="width:100%"  @change="changeSession">
								<el-option v-for="(item,index) in sessionIdNameList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<small class="color-warning">对于具有多个场次的演出，请仔细选择上传的场次，每个场次都需要单独上传售票数据<br>如果需要上传通票，则要求选择通票绑定的任一场次，之后无须再到其他场次上传，就能自动成为通票</small>
						</el-form-item>
						<el-form-item prop="ticketId" label="票品名称:" :rules="[{required: true, message: '票品名称不能为空'}]" >
							<el-select v-model="formData.ticketId" size="small" style="width:100%" @change="changeTicketName">
								<el-option v-for="(item,index) in ticketNameListNew" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<small class="color-warning">选填，文本格式，任意填写，如:预售票、现场票等，如果不填写，会默认为【线下票】<br>当票code为空时，填写的票品名称必须跟秀动平台售票名称一致，之后会自动继承对应票品的所有设置(如限购、转票规则等)</small>
						</el-form-item>
						<el-form-item prop="playForm" label="渠道:">
							<el-input v-model="formData.playForm" placeholder="请输入渠道名称" size="medium" maxlength="40"></el-input>
							<small class="color-warning">选填，文本格式，任意填写，如:淘宝、大麦等，如果不填写，会默认为【线下渠道】.</small>
						</el-form-item>						
						<el-form-item prop="code" label="票code:">
							<el-input v-model="formData.code" placeholder="请输入票code" size="medium" maxlength="60"></el-input>
							<small class="color-warning">选填，文本格式，任意填写，如果不填写，则导入的票品名称必须与秀动系统中的票品名称一致.</small>
						</el-form-item>
						<el-form-item prop="documentName" label="观演人证件姓名:">
							<el-input v-model="formData.documentName" placeholder="请输入观演人证件姓名" size="medium" maxlength="20"></el-input>
							<small class="color-warning">选填，文本格式，任意填写</small>
						</el-form-item>
						<el-form-item prop="documentType" label="观演人证件类型:">
							<el-select v-model="formData.documentType" size="medium" placeholder="请选择证件类型" @change="formData.documentNumber = ''">
							    <el-option v-for="(item,index) in documentTypeList" :key="index" :value="item.label" :label="item.label"></el-option>
							</el-select>
							<small class="color-warning">选填，如果填了证件号码，必须选择一个证件类型<br>支持身份证,港澳居民来往内地通行证,台湾居民来往大陆通行证,护照,外国人永久居留身份证,港澳台居民居住证</small>
						</el-form-item>
						<el-form-item prop="documentNumber" label="观演人证件号码:">
							<el-input v-model="formData.documentNumber" placeholder="请输入观演人证件号码" size="medium"></el-input>
							<small class="color-warning">跟用户手机之间至少填写一项，如果有证件号码,注意选择观演人证件类型,否则会导入失败.</small>
						</el-form-item>
						<el-form-item prop="telephone" label="用户手机:">
							<el-input v-model="formData.telephone" placeholder="请输入用户手机" size="medium" maxlength="20"></el-input>
							<small class="color-warning">跟证件号码之间至少填写一项，无须填写国际区号</small>
						</el-form-item>
						<el-form-item prop="price" label="票品单价:">						    
						    <el-input-number style="width:100%" v-model="formData.price" :precision="2" controls-position="right" :min="0" :max="99999999.99" size="medium" placeholder="请输入商品价格"></el-input-number>
							<small class="color-warning">选填，小数格式，精确到小数点后2位，如果属于免费票，请填写【0.00】</small>
						</el-form-item>
					</el-form>
				</div>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="submitForm(1)" :loading="btnLoading"
                    >提交</el-button>
				<el-button type="primary" @click="submitForm(2)" :loading="btnLoading1"
				    >提交并继续</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
const defaultFormData = {
    sessionId:'',
	ticketId:'',
	ticketName:'',
	playForm:'',
	code:'',
	documentName:'',
	documentType:'',
	documentNumber:'',
	telephone:'',
	price:''
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: '',
        },
        sessionIdNameList: {
            type: Array,
            default: () => []
        },
        activity: {
            type: Object,
            default: null
        }
    },
    components:{},
    data(){
        return{
           drawerShow:false,
		   btnLoading:false,
		   btnLoading1:false,
           formData:{...defaultFormData},
		   TicketNameList: [],
		   ticketNameListNew:[]
        }
    },
	computed:{
	    documentTypeList(){
	        return [{
	            label:'身份证',
	            value:1
	        },{
	            label:'港澳居民来往内地通行证',
	            value:2
	        },{
	            label:'台湾居民来往大陆通行证',
	            value:3
	        },{
	            label:'护照',
	            value:4
	        },{
	            label:'外国人永久居留身份证',
	            value:5
	        },{
	            label:'港澳台居民居住证',
	            value:6
	        }]
	    }
	},
    methods:{
        show() {
            this.drawerShow = true;
			this.getTicketName()
        },
        close(){           
            this.drawerShow = false;
			this.formData = { ...defaultFormData };
        },
		getTicketName() {
		    this.$request({
		        url: '/activity/realName/select',
		        params: { activityId: parseInt(this.id) },
		        method: "post",
		    })
		        .then((res) => {
		            const { state, result } = res.data;
		            if (state == 1) {
		                this.TicketNameList = result || [];
		            }
		        })
		},
		changeTicketName(e){
			this.ticketNameListNew.map((item,index) => {
				if( item.id === e ){
					this.formData.ticketName = item.name
				}					
			})
		},
		changeSession(e){
			var detailsArray = []
			this.TicketNameList.forEach((tab, idx) => {										
				tab.tickets.map((item,index) => {
					if( tab.id === e ){
						detailsArray.push({
							id: item.id,
							name: item.name,							
						})
					}					
				})
			})
			this.ticketNameListNew = detailsArray
		},
		submitForm(type){
		    this.$refs['formData'].validate((valid) => {
		        if(valid){
					if( type == 1 ){
						this.btnLoading = true;
					}else{
						this.btnLoading1 = true;
					}		            
		            this.$request({
		                url: '/activity/realName/add',
		                method: "POST",
		                data:{
		                    ...this.formData
		                }
		            }).then(res=>{
		                const {state, msg} = res.data;
		                if (state == 1) {
		                    this.$message.success('操作成功');
							if( type == 1 ){
								this.$emit("onUpdate");
								this.close()
							}else{
								this.$emit("onUpdate");
								this.formData = { ...defaultFormData };
							}
		                    
		                } else {
		                    this.$message.error(msg || "请求失败");
		                }
		            }).catch(() => {
		                this.$message.error("请求错误");
		            }).finally(()=>{
		                if( type == 1 ){
		                	this.btnLoading = false;
		                }else{
		                	this.btnLoading1 = false;
		                }
		            })
		        }
		    })        
		}
    }
}
</script>

<style lang="scss" scoped>

</style>